'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  color: ', ';\n  font-size: 1.2rem;\n  .fa {\n    padding-right: 0.5rem;\n  }\n'], ['\n  text-align: center;\n  color: ', ';\n  font-size: 1.2rem;\n  .fa {\n    padding-right: 0.5rem;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #ccc;\n  border: 1px solid #333;\n  border-radius: 5px;\n  padding: 0.5rem;\n'], ['\n  background-color: #ccc;\n  border: 1px solid #333;\n  border-radius: 5px;\n  padding: 0.5rem;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  height: 200px;\n  width: 100%;\n  padding: 10px;\n  border: solid 1px #333;\n  background-color: #ccc;\n  box-sizing: border-box;\n  overflow-y: scroll;\n\n  div {\n    position: relative;\n    width: fit-content;\n    max-width: 90%;\n    background-color: white;\n    padding: 5px;\n    border-radius: 4px;\n    margin-bottom: 0.5rem;\n  }\n\n  div.left {\n    align-self: flex-start;\n  }\n\n  div.left:after {\n    content: "";\n    display: inline-block;\n    position: absolute;\n    left: -8.5px;\n    top: 7px;\n    height: 0px;\n    width: 0px;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    border-right: 8px solid white;\n  }\n\n  div.right {\n    align-self: flex-end;\n    margin-right: -2px;\n    background-color: #fcff8f;\n  }\n\n  div.right:after {\n    content: "";\n    display: inline-block;\n    position: absolute;\n    right: -8px;\n    top: 6px;\n    height: 0px;\n    width: 0px;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    border-left: 8px solid #fcff8f;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  height: 200px;\n  width: 100%;\n  padding: 10px;\n  border: solid 1px #333;\n  background-color: #ccc;\n  box-sizing: border-box;\n  overflow-y: scroll;\n\n  div {\n    position: relative;\n    width: fit-content;\n    max-width: 90%;\n    background-color: white;\n    padding: 5px;\n    border-radius: 4px;\n    margin-bottom: 0.5rem;\n  }\n\n  div.left {\n    align-self: flex-start;\n  }\n\n  div.left:after {\n    content: "";\n    display: inline-block;\n    position: absolute;\n    left: -8.5px;\n    top: 7px;\n    height: 0px;\n    width: 0px;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    border-right: 8px solid white;\n  }\n\n  div.right {\n    align-self: flex-end;\n    margin-right: -2px;\n    background-color: #fcff8f;\n  }\n\n  div.right:after {\n    content: "";\n    display: inline-block;\n    position: absolute;\n    right: -8px;\n    top: 6px;\n    height: 0px;\n    width: 0px;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    border-left: 8px solid #fcff8f;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 10px 0;\n  input, button {\n    box-sizing: border-box;\n    width: 100%;\n    font-size: 1.1rem;\n  }\n  input[type=submit] {\n    background-color: #333;\n    color: white;\n  }\n'], ['\n  padding: 10px 0;\n  input, button {\n    box-sizing: border-box;\n    width: 100%;\n    font-size: 1.1rem;\n  }\n  input[type=submit] {\n    background-color: #333;\n    color: white;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Title = _styledComponents2.default.h1(_templateObject, function (props) {
  return props.color || '#000';
});

var Info = _styledComponents2.default.div(_templateObject2);

var Messages = _styledComponents2.default.div(_templateObject3);

var Controls = _styledComponents2.default.div(_templateObject4);

/** @class ChatContent
  * A content representing a chat window
  * @param {string} boothID - the id of the booth this chat appears in
  */

var ChatContent = function (_Component) {
  _inherits(ChatContent, _Component);

  function ChatContent(props) {
    _classCallCheck(this, ChatContent);

    var _this = _possibleConstructorReturn(this, (ChatContent.__proto__ || Object.getPrototypeOf(ChatContent)).call(this, props));

    _this.state = {
      messages: props.initialText ? [{ fromUser: false, text: props.initialText }] : [],
      question: ""
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSend = _this.handleSend.bind(_this);
    _this.scrollToBottom = _this.scrollToBottom.bind(_this);
    return _this;
  }

  _createClass(ChatContent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToBottom();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: 'handleSend',
    value: function handleSend(event) {
      event.preventDefault();
      var messages = this.state.messages;
      messages.push({ fromUser: true, text: this.state.question });
      this.setState({
        question: "",
        messages: messages
      });
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      var scrollHeight = this.scrollRef.scrollHeight;
      var height = this.scrollRef.clientHeight;
      var maxScrollTop = scrollHeight - height;
      this.scrollRef.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }
    /** @function
     * Renders the Title Content component.
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (true) {
        var messages = this.state.messages.map(function (message, index) {
          return _react2.default.createElement(
            'div',
            { key: 'message-' + index, className: message.fromUser ? 'left' : 'right' },
            message.text
          );
        });
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            Title,
            null,
            _react2.default.createElement(_reactFontawesome2.default, { name: 'comment' }),
            'Chat With Us'
          ),
          _react2.default.createElement(
            Messages,
            { innerRef: function innerRef(elm) {
                return _this2.scrollRef = elm;
              } },
            messages
          ),
          _react2.default.createElement(
            Controls,
            null,
            _react2.default.createElement(
              'form',
              { onSubmit: this.handleSend },
              _react2.default.createElement('input', { type: 'text', name: 'question',
                placeholder: 'Type your question...',
                value: this.state.question,
                onChange: this.handleChange
              }),
              _react2.default.createElement('input', { type: 'submit', value: 'SEND' })
            )
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            Title,
            null,
            _react2.default.createElement(_reactFontawesome2.default, { name: 'envelope' }),
            'Contact Us'
          ),
          _react2.default.createElement(
            Info,
            null,
            'Chat is currently unavailable, but send us an email and we\'ll respond as quickly as we can.'
          )
        );
      }
    }
  }]);

  return ChatContent;
}(_react.Component);

exports.default = ChatContent;


ChatContent.propTypes = {
  boothID: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/chat-content.js
// module id = 655
// module chunks = 0